<div class="md-content rd-3">
  <div class="md-header">
    <i class="material-icons md-close" (click)="close()">close</i>
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="client-header">
          <div class="item">
            <h3>{{ client.firstName }} {{ client.lastName }}</h3>
            @if (client.lastVisitTimeAgo) {
              <p class="text-small text-gray mb-2">
                {{ 'DASHBOARD.clientForm.lastVisitHeader' | translate }} {{ client.lastVisitTimeAgo }}
              </p>
            }
            <span class="client-badges">
              @if (targetGroupName) {
                <span class="pill mr-2">{{ targetGroupName }}</span>
              }
              <app-client-loyalty-score [clientName]="client?.firstName + ' ' + client?.lastName" [clientId]="client?.id" />
            </span>
          </div>
        </div>
      </div>
      @if (!loading && !shouldHideGeneralTab()) {
        <div class="col-md-6 client-actions">
          @if (!showForm) {
            <button type="button" class="btn btn-md btn-secondary mr-2" (click)="editClient()">
              {{ 'DASHBOARD.clientForm.editClient' | translate }}
            </button>
          }
          @if (canCreateBooking()) {
            <button type="button" class="btn btn-md btn-primary mr-2" (click)="newBooking()">
              {{ 'CLIENT.clientPage.newBooking' | translate }}
            </button>
          }
          <button dropdownToggle type="button" dropdown class="btn btn-md btn-secondary position-relative pr-3">
            <span class="selector d-flex align-items-center">
              <i class="material-icons icon">more_horiz</i>
            </span>
            <ul *dropdownMenu class="dropdown-menu more-menu">
              @if (client.phoneNumber) {
                <li>
                  <a class="dropdown-item" href="https://wa.me/{{ client.phoneNumber }}" target="_blank">
                    {{ 'DASHBOARD.clientForm.whatsapp' | translate }}
                  </a>
                </li>
              }
              <li>
                <a class="dropdown-item" (click)="deleteClient()">
                  {{ 'DASHBOARD.clientForm.deleteClient' | translate }}
                </a>
              </li>
              @if (!client.blacklist) {
                <li>
                  <a class="dropdown-item" (click)="addToBlacklist()">
                    {{ 'DASHBOARD.clientForm.addToBlacklist' | translate }}
                  </a>
                </li>
              }
              @if (client.blacklist) {
                <li>
                  <a class="dropdown-item" (click)="removeFromBlacklist()">
                    {{ 'DASHBOARD.clientForm.removeFromBlacklist' | translate }}
                  </a>
                </li>
              }
            </ul>
          </button>
        </div>
      }
    </div>
  </div>

  @if (!loading) {
    <ul class="tabs">
      @if (!shouldHideGeneralTab()) {
        <li>
          <h4 (click)="slideNum = 1" [ngClass]="{ active: slideNum === 1 }">{{ 'DASHBOARD.clientForm.general' | translate }}</h4>
        </li>
      }
      @if (client) {
        <li>
          <h4 (click)="slideNum = 2" [ngClass]="{ active: slideNum === 2 }">
            {{ 'DASHBOARD.clientForm.bookings' | translate }}
          </h4>
        </li>
      }
      @if (store?.salesModuleActive) {
        <li>
          <h4 (click)="slideNum = 3" [ngClass]="{ active: slideNum === 3 }">
            {{ 'DASHBOARD.clientForm.sales' | translate }}
          </h4>
        </li>
      }
      @if (merchantCustomFields?.length) {
        <li>
          <h4 (click)="slideNum = 4" [ngClass]="{ active: slideNum === 4}">
            {{ 'DASHBOARD.clientForm.customFields' | translate }}
          </h4>
        </li>
      }
      @if (client) {
        <li>
          <h4 (click)="slideNum = 5" [ngClass]="{ active: slideNum === 5 }">
            {{ 'DASHBOARD.clientForm.files' | translate }}
          </h4>
        </li>
      }
    </ul>
  }

  @if (loading) {
    <div class="md-body">
      <div class="d-flex w-100 justify-content-center p-3">
        <app-loader />
      </div>
    </div>
  }
  @if (!loading) {
    <div class="md-body">
      @if (slideNum === 1 && !shouldHideGeneralTab()) {
        <div class="row">
          <div class="col-md-6">
            <h4>{{ 'DASHBOARD.clientForm.personalInfo' | translate }}</h4>
            @if (!showForm) {
              <div class="form-row">
                <div class="col-6 mb-3">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.phone' | translate }}</p>
                  <p class="text-primary text-small w-100 truncate d-flex align-items-center">
                    @if (client.phoneNumber) {
                      <a href="tel:{{ client.phoneNumber }}">{{ client.phoneNumber }}</a>
                    }
                    @if (!client.phoneNumber) {
                      -
                    }
                  </p>
                </div>
                <div class="col-6 mb-3">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.email' | translate }}</p>
                  <p class="text-primary text-small w-100 truncate">
                    @if (client.email) {
                      <a  href="mailto:{{ client.email }}">{{ client.email }}</a>
                    }
                    @if (!client.email) {
                      -
                    }
                  </p>
                </div>
                <div class="col-6 mb-3" *ifCountry="'!us'">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.vatNumber' | translate }}</p>
                  <p class="text-primary text-small w-100 truncate">{{ client.vatNumber || '-' }}</p>
                </div>
                <div class="col-6 mb-3">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.dob' | translate }}</p>
                  <p class="text-primary text-small w-100 truncate">{{ client.dob ? (client.dob | date : 'longDate') : '-'}}</p>
                </div>
                @if (client.gender) {
                  <div class="col-6 mb-3">
                    <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.gender' | translate }}</p>
                    <p class="text-primary text-small w-100 truncate">{{ client.gender ? ('GENERAL.gender.' + client.gender | translate) : '' }}</p>
                  </div>
                }
                <div class="col-6 mb-3">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.newClientForm.notifications' | translate }}</p>
                  @if (!client.unsubscribed) {
                    <p class="text-primary text-small">{{ 'DASHBOARD.newClientForm.subscribed' | translate }}</p>
                  }
                  @if (client.unsubscribed) {
                    <p class="text-danger">{{ 'DASHBOARD.newClientForm.unsubscribed' | translate }}</p>
                  }
                </div>
                <div class="col-12 mb-3">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.notes' | translate }}</p>
                  <p class="text-primary text-small prewrap ">{{ client.notes || '-' }}</p>
                </div>
              </div>
            }
            @if (form && showForm) {
              <form [formGroup]="form" (ngSubmit)="addClient()">
                <app-text-input label="{{ 'DASHBOARD.clientForm.name' | translate }}"
                  inputClasses="mb-2"
                  formControlName="name"
                  [submitAttempted]="submitAttempted"
                  placeholder="{{ 'DASHBOARD.clientForm.namePlaceholder' | translate }}"
                  invalidMsg="{{ 'DASHBOARD.clientForm.nameInvalid' | translate }}"
                  inputType="text"
                 />
                <app-text-input label="{{ 'DASHBOARD.clientForm.email' | translate }}"
                  inputClasses="mb-2"
                  formControlName="email"
                  [submitAttempted]="submitAttempted && form.get('email').enabled"
                  placeholder="{{ 'DASHBOARD.clientForm.emailPlaceholder' | translate }}"
                  invalidMsg="{{ 'DASHBOARD.clientForm.emailInvalid' | translate }}"
                  inputType="text"
                 />
                <div class="form-group">
                  <label for="">{{ 'DASHBOARD.clientForm.phone' | translate }}</label>
                  <app-phone-input controlName="phoneNumber" [form]="form" [submitAttempted]="submitAttempted"/>
                </div>
                @if (submitAttempted && !form.get('phoneNumber').valid) {
                  <div class="invalid-feedback">
                    {{ 'DASHBOARD.clientForm.phoneInvalid' | translate }}
                  </div>
                }
                <app-text-input *ifCountry="'!us'" label="{{ 'DASHBOARD.clientForm.vatNumber' | translate }}" inputClasses="mb-2" formControlName="vatNumber"
                  [submitAttempted]="submitAttempted && form.get('vatNumber').enabled"
                  placeholder="{{intlService.getCurrentCountry()?.toUpperCase()}}999999999"
                invalidMsg="{{ 'SHARED.paymentModal.vatNumberInvalid' | translate: {value: intlService.getCurrentCountry()?.toUpperCase() } }}" inputType="text" />
                <app-dropdown-input-v2 label="{{ 'DASHBOARD.clientForm.gender' | translate }}"
                  placeholder="{{ 'DASHBOARD.clientForm.gender' | translate }}"
                  [options]="genderOptions"
                  [submitAttempted]="submitAttempted"
                  textOption="label"
                  formControlName="gender"
                   />
                <div class="form-group">
                  <label>{{ 'DASHBOARD.clientForm.dob' | translate }}</label>
                  <input
                    type="text"
                    [class.is-invalid]="submitAttempted && !form.get('dob').valid"
                    class="form-control mb-3"
                    bsDatepicker
                    formControlName="dob"
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                    />
                </div>
                <div class="form-group">
                  <label for="">{{ 'DASHBOARD.clientForm.notes' | translate }}</label>
                  <textarea
                    cols="30"
                    rows="3"
                    class="form-control"
                    placeholder="{{ 'DASHBOARD.clientForm.notesPlaceholder' | translate }}"
                    formControlName="notes"
                  ></textarea>
                </div>
                <div class="custom-control custom-checkbox">
                  <input formControlName="subscribed" type="checkbox" class="custom-control-input" id="subscribed" />
                  <label class="custom-control-label" for="subscribed">
                    {{ 'DASHBOARD.clientForm.subscribed' | translate }}
                  </label>
                </div>
                <app-alert [msg]="errorMsg" type="danger" />
                <div class="row actions">
                  <div class="col pl-0 pr-0">
                    <button type="button" class="btn btn-md btn-bg mr-1" (click)="cancelEdit()">{{ 'GENERAL.cancel' | translate }}</button>
                    <app-submit-btn class="float-right"
                      [loading]="saving"
                      [hasError]="errorMsg"
                      btnCopy="{{ 'GENERAL.save' | translate }}"
                     />
                  </div>
                </div>
              </form>
            }
          </div>
          <div class="col-md-6">
            <h4>
              {{ 'DASHBOARD.clientForm.stats' | translate }}
              <app-upgrade-button buttonType="pro" reasonName="ClientStats" (clicked)="bsModalRef.hide()"/>
            </h4>
            <div class="form-row" [ngClass]="{ blockStats: freemiumMode }">
              <div class="col-6 mb-1">
                <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.bookings' | translate }}</p>
                <h2>{{ stats?.bookings }}</h2>
              </div>
              @if (stats?.totalValue > 0) {
                <div class="col-6 mb-1">
                  <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.totalValue' | translate }}</p>
                  <h2>{{ stats?.totalValue | currency : (currentMerchant?.currency || 'EUR') }}</h2>
                </div>
              }
              <div class="col-6 mb-1">
                <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.complete' | translate }}</p>
                <h2>{{ stats?.complete }}</h2>
              </div>
              <div class="col-6 mb-1">
                <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.canceled' | translate }}</p>
                <h2>{{ stats?.canceled }}</h2>
              </div>
              <div class="col-6 mb-1">
                <p class="text-secondary text-small mb-1">{{ 'DASHBOARD.clientForm.noshow' | translate }}</p>
                <h2>{{ stats?.noshows }}</h2>
              </div>
            </div>
          </div>
        </div>
      }
      @if (slideNum === 2) {
        <div class="row justify-content-center">
          <div class="col-md-10">
            @if (loadingBookings) {
              <div class="d-flex w-100 justify-content-center p-3">
                <app-loader />
              </div>
            }
            @if (!loadingBookings) {
              <div class="client-history">
                @if (futureBookings?.length > 0) {
                  <ul class="list mb-4">
                    <h4>{{ 'DASHBOARD.clientForm.nextBookings' | translate }}</h4>
                    @for (booking of futureBookings; track booking) {
                      <ng-container [ngTemplateOutlet]="bookingItem" [ngTemplateOutletContext]="{ booking: booking }" />
                    }
                    @if (futureBookingsHasMore) {
                      <div class="w-100 text-center mt-3">
                        <button type="button" class="btn btn-md btn-secondary" (click)="loadMoreFutureBookings()" [disabled]="loadingMoreFutureBookings">
                          @if (!loadingMoreFutureBookings) {
                            <span>{{ 'DASHBOARD.clientForm.loadMore' | translate }}</span>
                          }
                          @if (loadingMoreFutureBookings) {
                            <app-loader />
                          }
                        </button>
                      </div>
                    }
                  </ul>
                }
                @if (pastBookings?.length > 0) {
                  <ul class="list mb-4">
                    <h4>{{ 'DASHBOARD.clientForm.history' | translate }}</h4>
                    @for (booking of pastBookings; track booking) {
                      <ng-container [ngTemplateOutlet]="bookingItem" [ngTemplateOutletContext]="{ booking: booking }" />
                    }
                    @if (pastBookingsHasMore) {
                      <div class="w-100 text-center mt-3">
                        <button type="button" class="btn btn-md btn-secondary" (click)="loadMorePastBookings()" [disabled]="loadingMorePastBookings">
                          @if (!loadingMorePastBookings) {
                            <span>{{ 'DASHBOARD.clientForm.loadMore' | translate }}</span>
                          }
                          @if (loadingMorePastBookings) {
                            <app-loader />
                          }
                        </button>
                      </div>
                    }
                  </ul>
                }
                <ng-template #bookingItem let-booking="booking">
                  <li>
                    <div
                      class="box"
                      [class.clickable]="canOpenBooking(booking)"
                      (click)="openBooking(booking)"
                      >
                      <div class="d-flex justify-content-between mb-1">
                        <div class="d-flex align-items-center">
                          @if (!booking.noshow && !booking.deletedAt) {
                            <i class="ico material-icons mr-1">event_available</i>
                          }
                          @if (booking.noshow || booking.deletedAt) {
                            <i class="ico-red material-icons mr-1">event_busy</i>
                          }
                          @if (booking?.providerSelected) {
                            <span>
                              <i title="{{ 'DASHBOARD.calendarPage.providerSelected' | translate }}" class="material-icons icon heart">favorite</i>
                            </span>
                          }
                          @if (booking.dateInit) {
                            <p class="date">
                              {{ booking.dateInit | dateFix | date : ('d MMM y ' + timeFormat) }}
                            </p>
                          }
                        </div>
                        @if (booking.deletedAt) {
                          <p class="text-bold">{{ 'CLIENT.clientPage.canceled' | translate }}</p>
                        }
                      </div>
                      <p>
                        <strong>{{ booking?.service?.name }}</strong>
                        ({{ booking?.provider?.name }})
                      </p>
                      @if (booking.notes) {
                        <p>
                          {{ booking.notes }}
                        </p>
                      }
                      <span>
                        @if (booking.source) {
                          <p>{{ 'DASHBOARD.clientForm.source' | translate }}: {{ booking.source }}</p>
                        }
                        <p>
                          {{ 'DASHBOARD.clientForm.createdBy' | translate }} {{ booking.createdBy ? booking.createdBy : ('DASHBOARD.clientForm.client' | translate)  }} {{ booking.createdAt | date : ('d MMM y ' + timeFormat) }}
                        </p>
                        @if (booking.deletedBy) {
                          <p>
                            {{ 'DASHBOARD.clientForm.canceledBy' | translate }} {{ booking.deletedBy }}
                            {{ booking.deletedAt | date : ('d MMM y ' + timeFormat) }}
                          </p>
                        }
                        @if (booking.totalAmountPaidCents > 0) {
                          <p>
                            {{ 'SHARED.createBookingModal.paidOnline' | translate }} {{ booking.totalAmountPaidCents / 100 | currency:booking?.currency:'symbol-narrow':'1.2-2'}}
                          </p>
                        }
                        @if (!booking.deletedBy && booking.deletedAt) {
                          <p>
                            {{ 'DASHBOARD.clientForm.canceledByCustomer' | translate }}
                            {{ booking.deletedAt | date : ('d MMM y ' + timeFormat) }}
                          </p>
                        }
                        @if (booking.noshow) {
                          <p>
                            {{ 'CLIENT.clientPage.noshow' | translate }}
                          </p>
                        }
                      </span>
                    </div>
                  </li>
                </ng-template>
                @if (hasNoBookings()) {
                  <p class="book-empty text-center">{{ 'DASHBOARD.clientForm.emptyBookings' | translate }}</p>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (slideNum === 3) {
        <app-client-sales [client]="client" />
      }
      @if (slideNum === 4) {
        <div class="row justify-content-center">
          <div class="col-md-10">
            @if (loadingExtraFields) {
              <div class="d-flex w-100 justify-content-center p-3">
                <app-loader />
              </div>
            }
            <!-- SHOW INFO -->
            @if (!loadingExtraFields && !customFieldsForm) {
              <ul class="list mb-3">
                @for (field of merchantCustomFields; track field) {
                  <li>
                    @if (!field.key) {
                      <div class="box">
                        <div class="form-row">
                          <div class="col-6 text-left">
                            <p class="text-secondary text-small mb-0">{{ field.name }}</p>
                          </div>
                          <div class="col-6 text-right">
                            @if (field.type !== 'date') {
                              <p class="text-primary text-bold text-small mb-0">{{merchantClientCustomFieldsValue?.[field.id] || '-'}}</p>
                            }
                            @if (field.type === 'date') {
                              <p class="text-primary text-bold text-small mb-0">{{(merchantClientCustomFieldsValue?.[field.id] | date) || '-'}}</p>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </li>
                }
              </ul>
              <div class="col-12 mb-3 text-right d-flex justify-content-center">
                <button type="button" class="btn btn-md btn-bg mr-1" (click)="editMerchantCustomFields()">
                  {{ 'DASHBOARD.clientForm.editClient' | translate }}
                </button>
              </div>
            }
            <!-- EDIT FORM -->
            @if (customFieldsForm) {
              <form class="w-100" [formGroup]="customFieldsForm" (ngSubmit)="saveCustomFields()">
                <div class="mb-4">
                  @for (customField of merchantCustomFields; track customField) {
                    <div class="form-group">
                      @if (!customField.key && customField.type === 'dropdown') {
                        <app-dropdown-input
                          [label]="customField.name"
                          [placeholder]="customField.name"
                          [formControlName]="'_' + customField.id"
                          [submitAttempted]="submitAttempted"
                          [options]="customField.dropdownValues"
                          [invalidMsg]="'GENERAL.requiredField' | translate"
                          />
                      }
                      @if (!customField.key && customField.type === 'text') {
                        <app-text-input
                          [label]="customField.name"
                          [formControlName]="'_' + customField.id"
                          [submitAttempted]="submitAttempted"
                          [placeholder]="customField.name"
                          [invalidMsg]="'GENERAL.requiredField' | translate"
                          inputType="text" />
                      }
                      <!-- custom date  -->
                      @if (!customField.key && customField.type === 'date') {
                        <div class="form-group">
                          <label>{{ customField.name }}</label>
                          <input
                            type="text"
                            [class.is-invalid]="submitAttempted && !form.get('_' + customField.id).valid"
                            class="form-control mb-3"
                            bsDatepicker
                            [formControlName]="'_' + customField.id"
                            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                            />
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="mb-4 d-flex justify-content-center">
                  <button type="button" class="btn btn-md btn-bg mr-1" (click)="cancelEditMerchantCustomFields()">
                    {{ 'GENERAL.cancel' | translate }}
                  </button>
                  <app-submit-btn
                    [loading]="savingCustomFields"
                    [hasError]="errorMsg"
                    btnCopy="{{ 'GENERAL.save' | translate }}" />
                </div>
              </form>
            }
          </div>
        </div>
      }
      @if (slideNum === 5) {
        <app-client-attachments [client]="client" />
      }
    </div>
  }
</div>
